export enum NutritionalPreferences {
  PEOPLE_COUNT = 'people_count',
  DIET_PRACTICE = 'diet_practice',
  COURSE_COMPOSITION = 'course_composition',
  EXPRESS = 'express',
  COURSE_RANGE = 'moment',
  FRUITS_VEGETABLES_QUANTITY = 'fruits_vegetables_quantity',
  STARCHY_FOODS_FREQUENCY = 'starchy_foods_frequency',
  DRIED_VEGETABLES_FREQUENCY = 'dried_vegetables_frequency',
  FISH_FREQUENCY = 'fish_frequency',
  MEAT_FREQUENCY = 'meat_frequency',
  DRINK_FREQUENCY = 'drink_frequency',
}

export enum OnboardingStepType {
  NUMBER = 'NUMBER',
  SLIDER = 'SLIDER',
  RADIO = 'RADIO',
  INTERSTITIAL = 'INTERSTITIAL',
  INTRODUCTION = 'INTRODUCTION',
  GENERATION = 'GENERATION',
}

export enum NutritionalWeight {
  MINIMAL = 'minimal',
  MEDIUM = 'medium',
  OPTIMAL = 'optimal',
}

export enum RegimeValues {
  NONE = 'ALL',
  NO_PORK = 'NO_PORK',
  NO_MEAT = 'NO_MEAT',
  NO_FISH = 'NO_FISH',
  NO_EGG = 'NO_EGG',
}

export enum StructureValues {
  ENT_PLAT = 'ENT_PLAT',
  ENT_PLAT_DESSERT = 'ENT_PLAT_DESSERT',
  PLAT_DESSERT = 'PLAT_DESSERT',
}

export enum MomentValues {
  ONLY_LUNCH = 'ONLY_LUNCH',
  LUNCH_AND_DINNER = 'LUNCH_AND_DINNER',
  ONLY_DINNER = 'ONLY_DINNER',
}

export enum FruitsValues {
  PORTIONS_3 = 1,
  PORTIONS_4 = 2,
  PORTIONS_5 = 3,
}

export enum StarchyFoodsValues {
  PER_WEEK_1 = 1,
  PER_WEEK_3 = 2,
  PER_WEEK_7 = 3,
}

export enum DriedVegetablesValues {
  RARELY = 1,
  PER_WEEK_1 = 2,
  PER_WEEK_2 = 3,
}

export enum FishFrequencyValues {
  RARELY = 1,
  PER_WEEK_1 = 2,
  PER_WEEK_2 = 3,
}

export enum MeatFrequencyValues {
  PER_WEEK_5 = 1,
  PER_WEEK_3 = 2,
  PER_WEEK_2 = 3,
}

export enum SugarFrequencyValues {
  PER_DAY_2 = 1,
  PER_DAY_1 = 2,
  RARELY = 3,
  NEVER = 4,
}

export const QuizzTypeOfUser = (value: string) => {
  if (value === QuizzQuestion1.TEEN) return 'ADO'
  if (value === QuizzQuestion1.PRO) return 'PRO'
  if (value === QuizzQuestion1.PARENT) return 'ADULTE'
  return 'ADO'
}

export enum QuizzRecommendationValue {
  SPORT_DAILY = 60,
  SPORT_INTENSE = 3,
  SCREEN_TIME = 2,
}

export enum QuizzQuestion1 {
  PARENT = 'PARENT',
  PRO = 'PRO',
  TEEN = 'TEEN',
}

export enum QuizzQuestionYesOrNo {
  YES = 'YES',
  NO = 'NO',
}

export enum QuizzQuestionWeek {
  PER_WEEK_1 = 1,
  PER_WEEK_2 = 2,
  PER_WEEK_3 = 3,
  PER_WEEK_4 = 4,
  PER_WEEK_5 = 5,
  PER_WEEK_6 = 6,
  PER_WEEK_7 = 7,
}

export enum QuizzQuestion8 {
  DURATION_0 = 'DURATION_0',
  DURATION_2 = 'DURATION_2',
  DURATION_3 = 'DURATION_3',
  DURATION_4 = 'DURATION_4',
  DURATION_6 = 'DURATION_6',
}

export enum QuizzQuestion16 {
  PER_PAUSE_0 = 1,
  PER_PAUSE_1 = 2,
  PER_PAUSE_2 = 3,
  PER_PAUSE_3 = 4,
}

export enum QuizDuration {
  DURATION_4 = 'DURATION_4',
  DURATION_1 = 'DURATION_1',
  DURATION_3 = 'DURATION_3',
  DURATION_2 = 'DURATION_2',
}

export enum FamilyProfile {
  PARENT = 'parent',
  CHILD_MIDDLE = 'children_middle',
  CHILD_SMALL = 'children_small',
}

export const getFamilyProfile = (profile: string): FamilyProfile => {
  if (profile === 'parent') return FamilyProfile.PARENT
  if (profile === 'children_middle') return FamilyProfile.CHILD_MIDDLE
  if (profile === 'children_small') return FamilyProfile.CHILD_SMALL
  return FamilyProfile.CHILD_SMALL
}
